import LogoSvgComponent from "@assets/svg/logo";
import React from "react";
import LogoTextComponent from "./LogoTextComponent";
import LogoNewSvgComponent from "@assets/svg/logo-new";

function SideMenuLogo(props: any) {
  const { collapsed } = props;
  return (
    <div className="store-brand">
      <LogoNewSvgComponent size={18} />
      {!collapsed && <LogoTextComponent />}
    </div>
  );
}

export default SideMenuLogo;
